export const formatCurrency = (number: number) => {
  const price = Number(number);
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(price);
};
